module.exports = __webpack_public_path__ + "static/media/21.6c207a2a.jpg";